module.exports = __webpack_public_path__ + "static/listen-on-spotify-af6a751ce365273220cc04ab451450e0.svg";